
const videourl = "https://api.evolvejobs.de/pp/api/public/videos";
//const videourl = "http://apievcustomer.de/pp/api/public/videos";
export default videourl;